module.exports = __webpack_public_path__ + "9525de03d87d6a4467a16d9ff7e94b04.png";